export default "__VITE_ASSET__CJmG8M4r__"